import React, { useMemo } from 'react'
import './level-progress.styles.scss'
import ProgressBar from '@/components/SHARED/progress-bar/progress-bar.component'

// Shows how far the player is between their current level floor and the next level.
// Progress is based on the player's points against active levels' opt_pointMinimum.
const LevelProgress = ({
  playerData,
  gameElements,
  barId,
  compact
}) => {

  const progress = useMemo(() => {
    if (!playerData || !gameElements) return null;
    const points = Number(playerData.points) || 0;
    const levels = Object.values(gameElements)
      .filter(e => e.type === 'level' && e.status === 'active')
      .sort((a, b) => Number(a.opt_pointMinimum) > Number(b.opt_pointMinimum) ? 1 : -1)
    if (levels.length === 0) return null;

    const nextLevel = levels.find(l => Number(l.opt_pointMinimum) > points);
    if (!nextLevel) return { maxed: true, percent: 100 };

    const reached = levels.filter(l => Number(l.opt_pointMinimum) <= points);
    const floor = reached.length > 0 ? Number(reached[reached.length - 1].opt_pointMinimum) : 0;
    const target = Number(nextLevel.opt_pointMinimum);
    const span = target - floor;
    const percent = span > 0 ? Math.min(100, Math.max(0, ((points - floor) / span) * 100)) : 0;
    const earned = playerData.levels?.[nextLevel.id]?.count > 0;
    const nextName = (earned || nextLevel.opt_preview) ? nextLevel.name : 'the next level';

    return {
      maxed: false,
      percent,
      remaining: target - points,
      nextName
    };
  }, [playerData, gameElements])

  if (!progress) return null;

  return (
    <div className={`level-progress ${compact ? 'compact' : ''}`}>
      <ProgressBar progressValue={progress.percent} itemId={barId} />
      <div className='level-progress-text'>
        {
          (progress.maxed)
            ? 'Congrats! Top level reached!'
            : <><b>{progress.remaining.toLocaleString()} XP</b> to reach {progress.nextName}</>
        }
      </div>
    </div>
  )
}

export default LevelProgress
